import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=505b2572&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"
import style0 from "./Config.vue?vue&type=style&index=0&id=505b2572&prod&lang=scss&scoped=true"
import style1 from "./Config.vue?vue&type=style&index=1&id=505b2572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b2572",
  null
  
)

export default component.exports